import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./NHSEczemaProgram.css";

const NHSEczemaProgram = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id") || "";
  const [scoradLink, setScoradLink] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    if (!id) { setLoading(false); return; }
    lifestyleApi.linkNavigate({ id })
      .then((res) => {
        setScoradLink(res.data.data?.link || "");
      })
      .catch((err) => console.error("linkNavigate:", err))
      .finally(() => setLoading(false));
  }, [id]);

  const handleProceed = () => {
    if (scoradLink) window.location.href = scoradLink;
  };

  return (
    <section className="nhs-page">
      <motion.div
        className="nhs-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h1
          className="nhs-title"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          {t("nhsProgram.title")}
        </motion.h1>
        <motion.p
          className="nhs-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          {t("nhsProgram.subtitle")}
        </motion.p>
        {!loading && scoradLink && (
          <motion.button
            className="nhs-proceed-btn"
            onClick={handleProceed}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            {t("nhsProgram.proceed")}
          </motion.button>
        )}
      </motion.div>
    </section>
  );
};

export default NHSEczemaProgram;
